'use es6';

import PropTypes from 'prop-types';
import { DragDropContext } from 'react-dnd';
import ReactDnDHTML5Backend from 'react-dnd-html5-backend';
import { jsx as _jsx } from "react/jsx-runtime";
export default function connectDnd(ComponentToDecorate, backend = ReactDnDHTML5Backend) {
  const displayName = ComponentToDecorate.displayName || ComponentToDecorate.name || 'Component';
  const DndContextComponent = DragDropContext(backend)(ComponentToDecorate);
  const wrapper = (props, {
    dragDropManager
  }) => {
    if (!dragDropManager) {
      return /*#__PURE__*/_jsx(DndContextComponent, Object.assign({}, props));
    }
    return /*#__PURE__*/_jsx(ComponentToDecorate, Object.assign({}, props));
  };
  wrapper.displayName = `DragDropContextDecorator(${displayName})`;
  wrapper.contextTypes = {
    dragDropManager: PropTypes.object
  };
  wrapper.wrappedComponent = ComponentToDecorate;
  return wrapper;
}
export const WEBPACK_3_FORCE_MODULE_IMPORT = 1;